export default "__VITE_ASSET__CA8cjoES__"